import DataLayerManager from "./dataLayerManager";
import ScrollManager from "@web/vpt-assets/assets/js/utilities/scrollManager";
import URLUTMGetter from "@web/vpt-assets/assets/js/utilities/interaction/URLUTMGetter";

export default class NewsletterDataLayerGenerator {
    constructor() {
        this.dataLayerManager = new DataLayerManager();
        this.scrollManager = new ScrollManager();
    }

    generateDataLayerData(eventCategory, eventDetail1) {
        let parameters = {
            event: "newsletter",
            event_category: eventCategory,
            event_detail_1: eventDetail1,
        };
        let urlUtmGetter = new URLUTMGetter(true);
        let utms = urlUtmGetter.get();

        if (utms.source &&
            utms.medium &&
            utms.campaign) {
            parameters.source = utms.source;
            parameters.medium = utms.medium;
            parameters.campaign = utms.campaign;
            if (utms.content) {
                parameters.content = utms.content;
            }
            if (utms.term) {
                parameters.term = utms.term;
            }
        } else {
            parameters.source = utms.source;
            parameters.medium = utms.medium;
        }

        this.dataLayerManager.pushData(JSON.stringify(parameters));
    }
}

NewsletterDataLayerGenerator.eventStatusStart = "newsletter_start";
NewsletterDataLayerGenerator.eventStatusTry = "newsletter_try";
NewsletterDataLayerGenerator.eventStatusSuccess = "newsletter_success";

NewsletterDataLayerGenerator.lightbox = 'lightbox';
NewsletterDataLayerGenerator.register = 'user-registration';
NewsletterDataLayerGenerator.book = 'check-purchase ';